import api from "../../config/api";

const state = {
    autoEngineData: ""
}

const mutations = {
    setAutoEngineData(state, payload) {
        state.autoEngineData = payload;
    },
}

const actions = {
    async fetchAutoEngine({ commit }, locationID) {
        try {
            await api.post(`/managelocationajax`, {
                cmd: "getautoenginemonthyeartotals",
                locationid: locationID
            })
                .then((response) => {
                    commit('setAutoEngineData', response.data.output);
                })
                .catch((error) => {
                    console.log("Error in getting Auto Engine Data", error);
                });
        } catch (error) {
            console.error('Error in getting Auto Engine Data:', error);
        }
    }
}

const getters = {
    stAutoEngineData: state => state.autoEngineData
}

export default {
    state,
    mutations,
    actions,
    getters
}